"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const styles_1 = require("./styles");

const react_1 = require("react");

const Icons_1 = require("../Icons");

const ALLOWED_IMAGE_TYPES = 'image/png,image/jpeg,image/x-png';

const PhotoUpload = props => {
  const [selectedFile, setSelectedFile] = (0, react_1.useState)();
  const [preview, setPreview] = (0, react_1.useState)();
  const [loading, setLoading] = (0, react_1.useState)(false); // create a preview as a side effect, whenever selected file is changed

  (0, react_1.useEffect)(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl); // free memory when ever this component is unmounted

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const uploadClb = (file, failed = false) => {
    setLoading(false);

    if (failed) {
      setSelectedFile(undefined);
      return;
    }

    if (props.afterUpload) {
      props.afterUpload(file);
    }
  };

  const removeClb = (failed = false) => {
    if (failed) {
      setLoading(false);
      return;
    }

    if (selectedFile) {
      setSelectedFile(undefined);
    }

    if (preview) {
      setSelectedFile(undefined);
    }

    setLoading(false);

    if (props.afterRemove) {
      props.afterRemove();
    }
  };

  const onSelectFile = e => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    const file = e.target.files[0];
    setSelectedFile(file);
    setLoading(true);

    if (props.beforeUpload) {
      props.beforeUpload(file);
    }

    if (props.upload) {
      props.upload(file, failed => uploadClb(file, failed));
    } else {
      uploadClb(file);
    }
  };

  const removePhoto = () => {
    setLoading(true);

    if (props.beforeRemove) {
      props.beforeRemove();
    }

    if (props.remove) {
      props.remove(removeClb);
    } else {
      removeClb();
    }
  };

  return (0, jsx_runtime_1.jsx)(styles_1.Container, {
    children: !selectedFile && !props.imageSrc ? (0, jsx_runtime_1.jsxs)(styles_1.StyledLabel, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.StyledInput, {
        disabled: !!selectedFile || loading,
        onChange: onSelectFile,
        accept: props.imageType || ALLOWED_IMAGE_TYPES
      }, void 0), (0, jsx_runtime_1.jsx)(Icons_1.CameraPlus, {}, void 0)]
    }, void 0) : (0, jsx_runtime_1.jsxs)(styles_1.ThumbnailContainer, Object.assign({
      loading: loading
    }, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.Thumbnail, {
        src: preview || props.imageSrc
      }, void 0), !props.dsiableRemove && !loading && (0, jsx_runtime_1.jsx)(styles_1.RightBottomTool, {
        children: (0, jsx_runtime_1.jsx)(styles_1.IconBtn, Object.assign({
          onClick: removePhoto
        }, {
          children: (0, jsx_runtime_1.jsx)(Icons_1.Trash, {}, void 0)
        }), void 0)
      }, void 0)]
    }), void 0)
  }, void 0);
};

exports.default = PhotoUpload;